<template>
  <el-button @click="handleClick" v-bind="$attrs" v-if="isAuth">
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  props: {
    code: {
      default: "",
    },
  },
  computed: {
    isAuth() {
      return !this.code || this.$store.getters.isAuth(this.code);
    },
  },
  methods: {
    handleClick(evt) {
      this.$emit("click", evt);
    },
  },
};
</script>

<style scoped lang="scss" >
.auth-button {
  font-size: 12px;
}
</style>
